import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import classNames from "classnames";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { listaBloque, registrarBloque, eliminarBloque } from "../../../service/CongifCursoHorario";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../../../actions";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { isNotVacioNull, isNumerico, isLetrasEspacio, minMax, isValue, getResultValidar } from "../../../utilities/Validate";
import { useHistory } from "react-router-dom";
import { accionPermiso } from "../../../utilities/Seguridad";

export const PageBloque = () => {
    const dispatch = useDispatch();
    const labelDialog = useRef({ title: "", labelButton: "", editAcceso: {}, visible: false, es_nuevo: false });

    const tipoBloque = [
        { name: 'Recreo', id: 1 },
        { name: 'Clases', id: 2 },
        { name: 'Taller', id: 3 },
    ];

    const bloqueName = {}
    bloqueName[1] = "Recreo"
    bloqueName[2] = "Clases"
    bloqueName[3] = "Taller"

    let claseBloque = {
        id: null,
        nombre: "",
        duracion: "",
        tipo: ""
    };

    let claseBloqueValidate = {
        id: { estado: null, mensaje: "", validar: isValue, minmax: false },
        nombre: { estado: true, mensaje: "Valor requerido letras con longitud min 3, max. 45", validar: isLetrasEspacio, minmax: true, min: 3, max: 45 },
        duracion: { estado: true, mensaje: "Valor requerido Número", validar: isNumerico },
        tipo: { estado: true, mensaje: "Valor requerido", validar: isNotVacioNull, minmax: false },
    };

    const [globalFilter, setGlobalFilter] = useState("");
    const [visibleDialog, setVisibleDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const toast = useRef(null);

    const [tablaData, setTablaData] = useState([]);
    const [bloqueData, setBloqueData] = useState(claseBloque);
    const [bloqueDataValidate, setBloqueDataValidate] = useState(claseBloqueValidate);

    // Permisos
    const history = useHistory();
    const permisos = useRef({ superusuario: false, acciones: [] });
    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    try {
        permisos.current.superusuario = usuario.superusuario;
        permisos.current.acciones = usuario.permisos.mantenedor.bloque.acciones;
    } catch (error) {
        permisos.current.acciones = [];
    }
    //----------------------------

    useEffect(() => {
        if (accionPermiso(permisos, "ver")) {
            loadListaBloque();
        } else {
            history.push("/Acceso");
        }
    }, [anio]);

    const loadListaBloque = async () => {
        if (colegio.id !== undefined) {
            dispatch(loading(true));
            var data = await listaBloque(colegio.id, usuario.token);
            if (data.error == 0) {
                setTablaData(data.talleres);
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }

            dispatch(loading(false));
        }
    }

    const saveGrado = async () => {
        setSubmitted(true);

        if (colegio.id !== undefined) {
            let validado = getResultValidar(bloqueData, bloqueDataValidate);

            setBloqueDataValidate(validado.result);

            if (validado.registra) {
                dispatch(loading(true));

                var data = await registrarBloque(colegio.id, bloqueData, usuario.token);

                if (data.error == 0) {
                    hideDialog();
                    loadListaBloque();
                    toast.current.show({ severity: "success", summary: "OK", detail: "Registros guardados!", life: 3000 });
                } else {
                    if (data.error == 1) {
                        toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                    } else {
                        console.log("Error");
                    }
                }
                dispatch(loading(false));
            }
        }
    };

    const viewNuevoCurso = () => {
        setVisibleDialog(true);
        labelDialog.current.title = "Nuevo Bloque";
        labelDialog.current.labelButton = "Registrar";
        labelDialog.current.es_nuevo = true;
        setBloqueData(claseBloque);
    };

    const viewDetalle = (row) => {
        labelDialog.current.visible = true;
        labelDialog.current.title = "Actualizar Bloque";
        labelDialog.current.labelButton = "Actualizar";
        labelDialog.current.es_nuevo = false;
        let dataEdit = { ...claseBloque };
        dataEdit.id = row.id;
        dataEdit.nombre = row.nombre == null ? "" : row.nombre;
        dataEdit.duracion = row.duracion == null ? "" : row.duracion;
        dataEdit.tipo = tipoBloque.find((o) => o.id === row.tipo);
        setVisibleDialog(true);
        setBloqueData(dataEdit);
    };

    const hideDialog = () => {
        setVisibleDialog(false);
        labelDialog.current.visible = false;
        setSubmitted(false);
        //setDataMatricula(null);
    };

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || "";
        let _detalla = { ...bloqueData };
        _detalla[`${name}`] = val;
        setBloqueData(_detalla);
    };

    const bodyTemplateDura = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]} mins.
            </>
        );
    }

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    }

    const bodyTemplateTipo = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {bloqueName[data[props.field]]}
            </>
        );
    };

    const eliminar = async (row) => {
        let data = await eliminarBloque(colegio.id, row.id, usuario.token);

        if (data.error == 0) {
            toast.current.show({ severity: "success", summary: "OK", detail: "Se eliminó el Bloque", life: 3000 });
            loadListaBloque();
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
    };

    const confirmDelete = (row) => {
        confirmDialog({
            message: "Estas seguro de eliminar el bloque?",
            header: "Eliminar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: () => eliminar(row),
        });
    };

    const dataTableHeader = (
        <div className="table-header">
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
            </span>

            <div className="flex align-items-center export-buttons">
                {accionPermiso(permisos, "crear") ? <Button type="button" icon="pi pi-plus" label="Bloque" className="mr-2 p-mr-1" onClick={viewNuevoCurso} tooltip="Nuevo Bloque" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button> : ""}
                <Button type="button" icon="pi pi-refresh" className="mr-2" onClick={loadListaBloque} tooltip="Actualizar" tooltipOptions={{ position: "bottom", mouseTrack: true, mouseTrackTop: 15 }}></Button>
            </div>
        </div>
    );

    const actionHerramienta = (rowData) => {
        return (
            <div className="actions">
                {accionPermiso(permisos, "editar") && rowData.editable == 1 ? <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => viewDetalle(rowData)} /> : ""}
                {accionPermiso(permisos, "eliminar") && rowData.editable == 1 ? <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDelete(rowData)} /> : ""}
            </div>
        );
    };

    const dialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label={labelDialog.current.labelButton} icon="pi pi-check" onClick={saveGrado} />
        </>
    );

    return (
        <div className="p-grid table-demo">

            <Toast ref={toast} />

            <DataTable value={tablaData} showGridlines paginator id="13" className="p-datatable-customers p-datatable-sm"
                rowsPerPageOptions={[10, 15, 30]}
                rows={10}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Reg. {first} - {last} de {totalRecords}"
                dataKey="id" rowHover globalFilter={globalFilter} emptyMessage="No existe información!" loading={false} header={dataTableHeader} metaKeySelection={true} size="small" responsiveLayout="scroll">
                <Column field="nombre" header="Bloque" sortable body={bodyTemplate}></Column>
                <Column field="tipo" header="Tipo Bloque" sortable body={bodyTemplateTipo}></Column>
                <Column field="duracion" header="Duracion" sortable body={bodyTemplateDura}></Column>
                <Column header="Acción" headerStyle={{ width: "8rem", textAlign: "center" }} bodyStyle={{ textAlign: "center", overflow: "visible", justifyContent: "center" }} body={actionHerramienta}></Column>
            </DataTable>

            <Dialog visible={visibleDialog} style={{ width: "40vw" }} breakpoints={{ "960px": "100vw" }} header={labelDialog.current.title} modal className="p-fluid" footer={dialogFooter} onHide={hideDialog}>
                <div className="p-formgrid p-grid p-col-12 p-p-0 p-mt-0">
                    <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                        <label htmlFor="name2">Nombre</label>
                        <InputText value={bloqueData.nombre} onChange={(e) => onInputChange(e, "nombre")} required className={classNames({ "p-invalid": submitted && !bloqueDataValidate.nombre.estado })} />
                        {submitted && !bloqueDataValidate.nombre.estado && <small className="p-error">{bloqueDataValidate.nombre.mensaje}</small>}
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                        <label htmlFor="name2">Tipo</label>
                        <Dropdown value={bloqueData.tipo} onChange={(e) => onInputChange(e, "tipo")} options={tipoBloque} optionLabel="name" placeholder="--" />
                        {submitted && !bloqueDataValidate.tipo.estado && <small className="p-error">{bloqueDataValidate.tipo.mensaje}</small>}
                    </div>

                    <div className="p-col-12 p-md-6 p-lg-6 p-mt-2">
                        <label htmlFor="namee">Duracion (Minutos)</label>
                        <InputNumber
                            inputId="minmax"
                            value={labelDialog.current.es_nuevo ? '' : bloqueData.duracion}
                            onValueChange={(e) => onInputChange(e, "duracion")}
                            showButtons
                            buttonLayout="horizontal"
                            step={1}
                            incrementButtonIcon="pi pi-plus"
                            decrementButtonIcon="pi pi-minus"
                            mode="decimal"
                            min={5} max={480}
                        />
                        {submitted && !bloqueDataValidate.duracion.estado && <small className="p-error">{bloqueDataValidate.duracion.mensaje}</small>}
                    </div>
                </div>
            </Dialog>

        </div>
    );
};
